import {
  BookOpen,
  BrainCircuit,
  Coffee,
  Compass,
  Flame,
  HeartHandshake,
  Leaf,
  Lightbulb,
  Mountain,
  Rocket,
  Scale,
  Sparkles,
  Target,
} from "lucide-react";

import { cn } from "@/lib/utils";
import { AuthenticatedImage } from "@/features/images/AuthenticatedImage";

const avatars = {
  friend: HeartHandshake,
  guide: Compass,
  coach: Target,
  analyst: BrainCircuit,
  creator: Lightbulb,
  companion: Sparkles,
  flame: Flame,
  scale: Scale,
  mountain: Mountain,
  leaf: Leaf,
  rocket: Rocket,
  coffee: Coffee,
  book: BookOpen,
};

export const AVATAR_KEYS = Object.keys(avatars);
export const ACCENT_COLORS = [
  "#BEF241",
  "#FF8066",
  "#F2994A",
  "#FFCB61",
  "#F7A8C4",
  "#9C8CFF",
  "#61C7FF",
  "#A8B5AD",
  "#C9B79C",
];

export function CharacterAvatar({
  avatarKey,
  accentColor,
  customAvatarUrl,
  className,
}: {
  avatarKey: string;
  accentColor: string;
  customAvatarUrl?: string | null;
  className?: string;
}) {
  const Icon = avatars[avatarKey as keyof typeof avatars] ?? Sparkles;
  return (
    <span
      className={cn(
        "relative grid shrink-0 place-items-center overflow-hidden rounded-[1.35rem] text-brand-forest shadow-[0_14px_35px_rgba(16,35,28,0.14)]",
        className
      )}
      style={{ backgroundColor: accentColor }}
      aria-hidden="true"
    >
      <span className="absolute -right-3 -top-3 h-10 w-10 rounded-full bg-white/30" />
      <Icon className="relative h-[42%] w-[42%] stroke-[2.2]" />
      {customAvatarUrl && (
        <AuthenticatedImage
          src={customAvatarUrl}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          fallback={null}
        />
      )}
    </span>
  );
}
